<rt-dialog-header
  [heading]="heading"
  [subheading]="
    showCountBeforeSubheading ? state.selectedAdminsCount + ' ' + subheading : subheading
  "
>
</rt-dialog-header>

<rt-dialog-body>
  <rt-spinner *ngIf="loadingAdmins"></rt-spinner>

  <rt-box *ngIf="!loadingAdmins" variant="vertical background no-padding">
    <div class="search">
      <rt-form-field variant="underlined search">
        <rt-icon name="search"></rt-icon>
        <rt-input
          variant="underlined large"
          [placeholder]="'app.common.search' | translate"
          [autoFocus]="true"
          [formControl]="searchControl"
          [hasClearButton]="isSearching()"
          (reset)="cancelSearch()"
        >
        </rt-input>
      </rt-form-field>

      <rt-group variant="horizontal" class="select-options">
        <rt-button variant="small plain no-padding" (click)="selectAll()">
          {{ 'app.common.all' | translate }}
        </rt-button>
        <rt-button variant="small plain no-padding" (click)="selectNone()">
          {{ 'app.common.none' | translate }}
        </rt-button>
      </rt-group>
    </div>

    <rt-divider variant="line"></rt-divider>

    <div #results class="results">
      <div
        *ngFor="let admin of admins | rtAdminFilter: searchControl.value; trackBy: trackByAdmin"
        class="result"
        [class.disabled]="currentAdminId === admin.id && preventAdminRemove"
      >
        <rt-group
          variant="horizontal"
          [class.checked]="adminCheckbox.checked"
          (click)="toggleAssignment(admin)"
        >
          <rt-checkbox
            #adminCheckbox
            [value]="$any(admin.id)"
            [checked]="assignmentsGroup.controls[admin.id]?.value"
            [formControl]="controlFor(admin)"
          >
          </rt-checkbox>
          <rt-avatar
            [type]="'image'"
            [size]="'base'"
            [shape]="'oval'"
            [imageSrc]="admin.photoThumbUrl"
          ></rt-avatar>
          <div margin-left-small layout-vertical>
            <rt-heading>{{ admin.firstName }} {{ admin.lastName }}</rt-heading>
            <span>{{ admin.email }}</span>
          </div>
        </rt-group>
        <rt-divider></rt-divider>
      </div>
    </div>
    <rt-empty-state
      *ngIf="!results.children.length"
      variant="small"
      [icon]="'search'"
      [title]="'app.common.no_results_found' | translate"
    >
      <rt-button variant="default small" (click)="cancelSearch()">
        {{ 'app.assignments.editor.clear_search' | translate }}
      </rt-button>
    </rt-empty-state>
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button *ngIf="!loading" variant="plain" (click)="cancel()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" [disabled]="!isValid()" [loading]="loading" (click)="submit()">
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
